import * as React from 'react';
import PropTypes from 'prop-types';

import { P } from '@decisiv/ui-components/lib/components/Typography';

import { t } from '@lingui/macro';

import AssetGroupingData from './AssetGroupingData';

function AssetGroupingEmail({ assetGrouping }) {
  return (
    <AssetGroupingData
      data={
        <P as="span" truncate>
          {assetGrouping?.email || '—'}
        </P>
      }
      titleText={t`Email`}
    />
  );
}

AssetGroupingEmail.propTypes = {
  assetGrouping: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string,
  }),
};

AssetGroupingEmail.defaultProps = {
  assetGrouping: undefined,
};

export default AssetGroupingEmail;
